(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ring-builder"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

const state = {
  step: 1,
  design: null,
  designPrice: null,
  designName: null,
  designImg: null,
  metalKey: null,
  metalName: null,
  shape: null,
  shapeImg: null,
  carat: null,
  caratPrice: null,
  size: null,
  twoStone: false
};

const caratOptions = Array.from(
  document.querySelectorAll("#rb-carat-select option")
).filter(o => o.value);

function formatPrice(n) {
  return "$" + parseInt(n, 10).toLocaleString();
}

  function getDesignPrice(card) {
    const k = state.metalKey;
    if (k === "10k" && card.dataset["price-10k"]) return card.dataset["price-10k"];
    if (k === "14k" && card.dataset["price-14k"]) return card.dataset["price-14k"];
    if (k === "18k" && card.dataset["price-18k"]) return card.dataset["price-18k"];
    if (k === "plat" && card.dataset.pricePlat) return card.dataset.pricePlat;
    return card.dataset["price-10k"] || card.dataset["price-14k"] || card.dataset["price-18k"] || card.dataset.pricePlat || "0";
  }

function totalPrice() {
  if (!state.designPrice) return null;
  if (state.twoStone) {
    if (!state.caratPrice || !state.caratPrice2) return null;
    return parseInt(state.designPrice, 10) + parseInt(state.caratPrice, 10) + parseInt(state.caratPrice2, 10);
  }
  if (!state.caratPrice) return null;
  return parseInt(state.designPrice, 10) + parseInt(state.caratPrice, 10);
}

function updatePreview() {
  const total = totalPrice();
  const priceEl = document.getElementById("rb-price-total");

    if (total) {
      priceEl.textContent = formatPrice(total);
    } else if (state.designPrice) {
      priceEl.textContent = "from " + formatPrice(state.designPrice);
    } else {
      priceEl.textContent = "—";
    }

    const img = document.getElementById("rb-preview-img");
    const iframe = document.getElementById("rb-preview-3d");
    const container = document.getElementById("rb-3d-container");
    const selectedCard = document.querySelector(".rb-design-card.selected");

    if (!selectedCard) {
      container.style.display = "none";
      img.style.display = "block";
      return;
    }

    const shapeKey = state.shape ? "3d" + state.shape.charAt(0).toUpperCase() + state.shape.slice(1) : null;
const render3d = (shapeKey && selectedCard.dataset[shapeKey]) || selectedCard.dataset["3d"] || null;

if (render3d) {
      img.style.display = "none";
      container.style.display = "block";
      if (iframe.src !== render3d) {
        iframe.src = render3d;
        // Try to auto-fit the ring when iframe loads
        iframe.addEventListener('load', function() {
          setTimeout(() => {
            try {
              iframe.contentWindow.postMessage({ action: 'fit' }, '*');
              iframe.contentWindow.postMessage({ action: 'fitToScene' }, '*');
              iframe.contentWindow.postMessage({ type: 'fit' }, '*');
              iframe.contentWindow.postMessage({ command: 'fit' }, '*');
            } catch(e) {
              console.log('postMessage attempt:', e);
            }
          }, 2000);
        });
      }
    } else if (state.designImg) {
      container.style.display = "none";
      iframe.src = "";
      img.style.display = "block";
      img.style.opacity = "0";
      setTimeout(() => { img.src = state.designImg; img.style.opacity = "1"; }, 150);
    }
  }

  function updateReviewPanel() {
    document.getElementById("rb-review-setting").textContent = state.designName
      ? `${state.designName} — ${formatPrice(state.designPrice)}` : "—";

    if (state.twoStone) {
      const s1 = state.shape ? state.shape.charAt(0).toUpperCase() + state.shape.slice(1) : "—";
      const s2 = state.shape2 ? state.shape2.charAt(0).toUpperCase() + state.shape2.slice(1) : "—";
      document.getElementById("rb-review-shape").textContent = `Stone 1: ${s1} / Stone 2: ${s2}`;
      const c1 = state.carat ? `${state.carat} (${formatPrice(state.caratPrice)})` : "—";
      const c2 = state.carat2 ? `${state.carat2} (${formatPrice(state.caratPrice2)})` : "—";
      document.getElementById("rb-review-carat").textContent = `Stone 1: ${c1} / Stone 2: ${c2}`;
    } else {
      document.getElementById("rb-review-shape").textContent = state.shape
        ? state.shape.charAt(0).toUpperCase() + state.shape.slice(1) : "—";
      document.getElementById("rb-review-carat").textContent = state.carat
        ? `${state.carat} — ${formatPrice(state.caratPrice)}` : "—";
    }

    document.getElementById("rb-review-metal").textContent = state.metalName || "—";
    document.getElementById("rb-review-size").textContent = state.size ? `Size ${state.size}` : "—";
    const total = totalPrice();
    document.getElementById("rb-review-total").textContent = total ? formatPrice(total) : "—";
    const agreementChecked = document.getElementById("rb-agreement-checkbox").checked;
    document.getElementById("rb-add-to-cart").disabled = !total || !state.size || !state.metalName || !agreementChecked;
  }

  function updateStep(n) {
    state.step = n;
    document.querySelectorAll(".rb-panel").forEach(p => {
      p.classList.toggle("active", parseInt(p.dataset.panel) === n);
    });
    document.querySelectorAll(".rb-step-item").forEach((s, i) => {
      const sn = i + 1;
      s.classList.toggle("active", sn === n);
      s.classList.toggle("completed", sn < n);
    });
    if (n === 4) updateReviewPanel();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  function activateTwoStoneMode() {
    document.getElementById("rb-single-stone").style.display = "none";
    document.getElementById("rb-two-stones").style.display = "block";
    document.getElementById("rb-diamond-title").innerHTML = 'Select Your Stones <span class="rb-section-subtitle">*Renders are displayed with a 1.5ct diamond</span>';;
    state.twoStone = true;
    state.shape = null;
    state.shape2 = null;
    state.carat = null;
    state.carat2 = null;
    state.caratPrice = null;
    state.caratPrice2 = null;
    checkStep2();
  }

  function activateSingleStoneMode() {
    document.getElementById("rb-single-stone").style.display = "block";
    document.getElementById("rb-two-stones").style.display = "none";
    document.getElementById("rb-diamond-title").innerHTML = 'Select Your Stone <span class="rb-section-subtitle">*Renders are displayed with a 1.5ct diamond</span>';;
    state.twoStone = false;
    state.shape2 = null;
    state.carat2 = null;
    state.caratPrice2 = null;
    checkStep2();
  }

  function checkStep2() {
    if (state.twoStone) {
      document.querySelector("[data-next='3']").disabled = !(state.shape && state.shape2 && state.carat && state.carat2);
    } else {
      document.querySelector("[data-next='3']").disabled = !(state.shape && state.carat);
    }
  }

  function checkStep3() {
    document.querySelector("[data-next='4']").disabled = !(state.metalName && state.size);
  }

  // ── Step 1: Category Tabs ──────────────────────────
  document.querySelectorAll(".rb-cat-btn").forEach(btn => {
    btn.addEventListener("click", () => {
      document.querySelectorAll(".rb-cat-btn").forEach(b => b.classList.remove("active"));
      btn.classList.add("active");
      const cat = btn.dataset.cat;
      document.querySelectorAll(".rb-designs").forEach(d => {
        d.classList.toggle("active", d.dataset.designs === cat);
      });
    });
  });

  // ── Step 1: Design Cards ───────────────────────────
  document.querySelectorAll(".rb-design-card").forEach(card => {
    card.addEventListener("click", () => {
      document.querySelectorAll(".rb-design-card").forEach(c => c.classList.remove("selected"));
      card.classList.add("selected");
      state.designName = card.dataset.design;
      state.designImg = card.dataset.img;
      state.designPrice = card.dataset["price-14k"];
      state.design3d = card.dataset["3d"] || null;
      if (state.designName.includes("Toi et Moi") || state.designName === "Toi et Moi Bezel") {
        activateTwoStoneMode();
      } else {
        activateSingleStoneMode();
      }
      updatePreview();
      document.querySelector("[data-next='2']").disabled = false;
    });
  });

  // ── Step 2: Shape Tiles ────────────────────────────
  document.querySelectorAll(".rb-shape-tile").forEach(tile => {
    tile.addEventListener("click", () => {
      const stoneNum = tile.dataset.stone;
      if (stoneNum === "2") {
        document.querySelectorAll("#rb-two-stones .rb-shape-tile[data-stone='2']").forEach(t => t.classList.remove("selected"));
        tile.classList.add("selected");
        state.shape2 = tile.dataset.shape;
      } else if (document.getElementById("rb-two-stones").style.display === "block") {
        document.querySelectorAll("#rb-two-stones .rb-shape-tile[data-stone='1']").forEach(t => t.classList.remove("selected"));
        tile.classList.add("selected");
        state.shape = tile.dataset.shape;
      } else {
        document.querySelectorAll("#rb-single-stone .rb-shape-tile").forEach(t => t.classList.remove("selected"));
        tile.classList.add("selected");
        state.shape = tile.dataset.shape;
      }
      updatePreview();
      checkStep2();
    });
  });

  // ── Step 2: Carat Sliders ──────────────────────────
  function syncCarat(idx, stoneNum) {
    const opt = caratOptions[idx];
    if (!opt) return;
    if (stoneNum === 2) {
      state.carat2 = opt.value;
      state.caratPrice2 = opt.dataset.price;
      const display2 = document.getElementById("rb-carat-display-2");
      if (display2) display2.textContent = opt.text;
    } else {
      state.carat = opt.value;
      state.caratPrice = opt.dataset.price;
      const display = document.getElementById("rb-carat-display") || document.getElementById("rb-carat-display-1");
      if (display) display.textContent = opt.text;
    }
    updatePreview();
    checkStep2();
  }

  const slider = document.getElementById("rb-carat-slider");
  if (slider) {
    slider.max = caratOptions.length - 1;
    slider.addEventListener("input", () => {
      syncCarat(parseInt(slider.value, 10), 1);
      const badge = document.getElementById("rb-most-popular-badge");
      if (badge) badge.style.display = slider.value === "4" ? "inline-block" : "none";
    });
    const defaultOpt = caratOptions[4];
    if (defaultOpt) document.getElementById("rb-carat-display").textContent = defaultOpt.text;
  }

  const slider1 = document.getElementById("rb-carat-slider-1");
  if (slider1) {
    slider1.max = caratOptions.length - 1;
    slider1.addEventListener("input", () => syncCarat(parseInt(slider1.value, 10), 1));
    const defaultOpt = caratOptions[4];
    if (defaultOpt) document.getElementById("rb-carat-display-1").textContent = defaultOpt.text;
  }

  const slider2 = document.getElementById("rb-carat-slider-2");
  if (slider2) {
    slider2.max = caratOptions.length - 1;
    slider2.addEventListener("input", () => syncCarat(parseInt(slider2.value, 10), 2));
    const defaultOpt = caratOptions[4];
    if (defaultOpt) document.getElementById("rb-carat-display-2").textContent = defaultOpt.text;
  }

  // ── Step 3: Metal Buttons ──────────────────────────
  document.querySelectorAll(".rb-metal-btn").forEach(btn => {
    btn.addEventListener("click", () => {
      document.querySelectorAll(".rb-metal-btn").forEach(b => b.classList.remove("selected"));
      btn.classList.add("selected");
      state.metalKey = btn.dataset.metalKey;
      state.metalName = btn.dataset.metal;
      document.querySelectorAll(".rb-design-card").forEach(card => {
        const price = getDesignPrice(card);
        card.querySelector(".rb-design-price").textContent = "from " + formatPrice(price);
      });
      const selectedCard = document.querySelector(".rb-design-card.selected");
      if (selectedCard) {
        state.designPrice = getDesignPrice(selectedCard);
      }
      updatePreview();
      checkStep3();
    });
  });

  // ── Step 3: Size Select ────────────────────────────
  document.getElementById("rb-size-select").addEventListener("change", function () {
    state.size = this.value;
    const sizerMessage = document.getElementById("rb-sizer-message");
    if (this.value === "unknown") {
      sizerMessage.style.display = "block";
      state.sizeUnknown = true;
    } else {
      sizerMessage.style.display = "none";
      state.sizeUnknown = false;
    }
    checkStep3();
  });

  // ── Next Buttons ───────────────────────────────────
  document.querySelectorAll(".rb-next-btn").forEach(btn => {
    btn.addEventListener("click", () => {
      if (!btn.disabled) updateStep(parseInt(btn.dataset.next, 10));
    });
  });

  // ── Progress Tracker ───────────────────────────────
  document.querySelectorAll(".rb-step-item").forEach(item => {
    item.addEventListener("click", () => {
      const n = parseInt(item.dataset.step, 10);
      if (n < state.step) updateStep(n);
    });
  });

  // ── Agreement Checkbox ─────────────────────────────
  document.getElementById("rb-agreement-checkbox").addEventListener("change", function() {
    const total = totalPrice();
    document.getElementById("rb-add-to-cart").disabled = !total || !state.size || !state.metalName || !this.checked;
  });

// ── Add to Cart ────────────────────────────────────
document.getElementById("rb-add-to-cart").addEventListener("click", async function () {

  const total = totalPrice();

  try {

    // Only load the Shopify variants when Add to Cart is clicked.
    // This cannot interfere with the ring-selection buttons loading.
    const response = await fetch('/products/custom-ring.js');

    if (!response.ok) {
      alert("Unable to load the Custom Ring product from Shopify.");
      return;
    }

    const product = await response.json();

    console.log("Variants returned by Shopify:", product.variants.length);
    console.log("Calculated total:", total);

    // Your Shopify option is named Price, and the option values
    // are numbers such as 1760, 3350, etc.
    const matchingVariant = product.variants.find(function (variant) {
      return String(variant.option1).replace(/[$,\s]/g, '') === String(total);
    });

    if (!matchingVariant) {

      console.log(
        "Shopify Price option values:",
        product.variants.map(function (variant) {
          return variant.option1;
        })
      );

      alert(
        "Calculated total: $" +
        total +
        "\nVariants returned by Shopify: " +
        product.variants.length +
        "\nNo matching Price variant was found."
      );

      return;
    }

    console.log("Matching variant:", matchingVariant);

    const cartResponse = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },

      body: JSON.stringify({
        items: [{
          id: matchingVariant.id,
          quantity: 1,

          properties: {
            "Setting": state.designName,

            "Diamond Shape": state.twoStone
              ? `Stone 1: ${state.shape} / Stone 2: ${state.shape2}`
              : state.shape,

            "Carat": state.twoStone
              ? `Stone 1: ${state.carat} / Stone 2: ${state.carat2}`
              : state.carat,

            "Diamond Price": state.twoStone
              ? `Stone 1: ${formatPrice(state.caratPrice)} / Stone 2: ${formatPrice(state.caratPrice2)}`
              : formatPrice(state.caratPrice),

            "Metal": state.metalName,

            "Ring Size": state.sizeUnknown
              ? "To be confirmed — ring sizer to be mailed"
              : state.size,

            "Total": formatPrice(total)
          }
        }]
      })
    });

    const cartData = await cartResponse.json();

    if (!cartResponse.ok) {
      console.error("Shopify cart error:", cartData);

      alert(
        cartData.description ||
        cartData.message ||
        "Unable to add this ring to the cart."
      );

      return;
    }

    window.location.href = '/cart';

  } catch (error) {

    console.error("Custom ring cart error:", error);

    alert(
      "There was a problem connecting the custom ring to Shopify."
    );
  }

});

});

  } catch(e) { console.error(e); }
})();
})();
